'use strict';

angular.module('chatEngine.dialog', ['ui.bootstrap'])

.controller('DialogCtrl', ['$scope', '$modalInstance', 'config',
    function($scope, $modalInstance, config) {
    $scope.title = config.title;
    $scope.message = config.message;
    $scope.type = config.type;
    $scope.okText = config.okText;
    $scope.cancelText = config.cancelText;
    $scope.ok = angular.bind($modalInstance, $modalInstance.close);
    $scope.cancel = angular.bind($modalInstance, $modalInstance.dismiss);
}])

.controller('DialogSelectionCtrl', ['$scope', '$controller', '$modalInstance', 'config',
    function($scope, $controller, $modalInstance, config) {
    angular.extend(this, $controller('DialogCtrl', {
        $scope: $scope,
        $modalInstance: $modalInstance,
        config: config
    }));

    $scope.items = config.items;
    $scope.selected = {item: config.selected};
    $scope.ok = function() {
        $modalInstance.close($scope.selected.item);
    };
}])

.controller('DialogEmailFormCtrl', ['$scope', '$controller', '$modalInstance', 'config',
    function($scope, $controller, $modalInstance, config) {
    angular.extend(this, $controller('DialogCtrl', {
        $scope: $scope,
        $modalInstance: $modalInstance,
        config: config
    }));

    $scope.invalid = {value: false, message: ''};

    $scope.textValue = '';
    $scope.placeholder = config.placeholder;
    $scope.users = config.users;

    $scope.ok = function() {
        if ($scope.textValue === undefined || $scope.textValue === '') {
            $scope.invalid.value = true;
            $scope.invalid.message = 'Please enter a valid email.';
        } else if ($scope.users.indexOf($scope.textValue) !== -1) {
            $scope.invalid.value = true;
            $scope.invalid.message = 'That email already exists.';
        } else {
            $modalInstance.close($scope.textValue);
        }
    };
}])

.factory('Dialog', ['$modal', function($modal) {
    var instance = null;
    var defaultConfig = {
        templateUrl: 'views/dialog.html',
        windowClass: 'dialog',
        controller: 'DialogCtrl'
    };

    var Dialog = {};

    Dialog.instance = function() {
        return instance;
    };

    Dialog.modal = function(config) {
        if(instance !== null) {
            throw new Error('Only one dialog at a time');
        }
        instance = $modal.open(angular.extend({}, defaultConfig, config));
        instance.result.finally(function() {
            instance = null;
        });
        return instance;
    };

    Dialog.alert = function(title, message) {
        return Dialog.modal({
            resolve: {
                config: function() {
                    return {
                        title: title,
                        message: message,
                        type: 'alert'
                    };
                }
            }
        });
    };

    Dialog.confirm = function(title, message, okText) {
        return Dialog.modal({
            backdrop: 'static',
            resolve: {
                config: function() {
                    return {
                        title: title,
                        message: message,
                        type: 'confirm',
                        okText: okText
                    };
                }
            }
        });
    };

    Dialog.selection = function(title, okText, items, selected) {
        return Dialog.modal({
            controller: 'DialogSelectionCtrl',
            templateUrl: 'views/dialog-selection.html',
            resolve: {
                config: function() {
                    return {
                        title: title,
                        okText: okText,
                        type: 'selection',
                        items: items,
                        selected: selected
                    };
                }
            }
        });
    };

    Dialog.emailForm = function(title, okText, placeholder, message, users) {
        return Dialog.modal({
            controller: 'DialogEmailFormCtrl',
            templateUrl: 'views/dialog-email.html',
            resolve: {
                config: function() {
                    return {
                        title: title,
                        okText: okText,
                        type: 'emailForm',
                        placeholder: placeholder,
                        message: message,
                        users: users
                    };
                }
            }
        });
    };
    return Dialog;
}]);
